import { sortBy } from "lodash";
import { Listing } from "@/shared/types/listings";

export default {
	state: {
		page: 0
	},
	actions: {
		setPageNumber(context: any, page: number) {
			context.commit("setPage", page);
		}
	},
	mutations: {
		setPage(state: any, page: number) {
			state.page = page;
		}
	},
	getters: {
		editorPage: (state: any): number => state.page as number,
		editorsListings: (state: any, getters: any): Listing[] => {
			return sortBy(getters.userListingsList, ["title"]) as Listing[];
		},
		editorsListingsPaid: (state: any, getters: any): Listing[] => {
			return sortBy(getters.userListingsList, ["title"]).filter(
				(listing) => listing.plan !== "free"
			) as Listing[];
		},
		editorsListingsIDs: (state: any, getters: any): number[] => {
			return getters.editorsListings.map(
				(l: Listing) => l.id
			) as number[];
		},
		editorsListingsIDsPaid: (state: any, getters: any): number[] => {
			return getters.editorsListingsPaid.map(
				(l: Listing) => l.id
			) as number[];
		},
		editorsCurrentListingID: (state: any, getters: any): number[] => {
			return getters.editorsListingsIDs[state.page] as number[];
		},
		editorsCurrentListingIDPaid: (state: any, getters: any): number[] => {
			return getters.editorsListingsIDsPaid[state.page] as number[];
		},
		editorsCurrentListing: (state: any, getters: any): Listing => {
			return getters.userListingGet(
				getters.editorsCurrentListingID
			) as Listing;
		},
		editorsCurrentListingPaid: (state: any, getters: any): Listing => {
			return getters.userListingGet(
				getters.editorsCurrentListingIDPaid
			) as Listing;
		},
		editorIsFetching: (state: any, getters: any): boolean => {
			return (!getters.userListingsHasFetched ||
				getters.userListingsIsFetching ||
				!getters.editorsCurrentListing) as boolean;
		}
	}
};
